export const ServiceIconConfig = {
    20: {
        borderRadius: 3,
        iconSize: 14,
        spacing: 5,
    },
    30: {
        borderRadius: 3,
        iconSize: 20,
        spacing: 5,
    },
    40: {
        borderRadius: 5,
        iconSize: 30,
        spacing: 5,
    },
    60: {
        borderRadius: 8,
        iconSize: 40,
        spacing: 10,
    },
    80: {
        borderRadius: 10,
        iconSize: 60,
        spacing: 20,
    },
    120: {
        borderRadius: 15,
        iconSize: 90,
        spacing: 30,
    },
    150: {
        borderRadius: 18,
        iconSize: 110,
        spacing: 40,
    },
};
//# sourceMappingURL=constants.js.map
// @zapier/design-system@6.3.0 (1dc71580e)
